export default __webpack_public_path__ + "static/media/keto_concentrate@2x.9f2d87b4.jpg";